import { render, staticRenderFns } from "./type2.vue?vue&type=template&id=2d05f728&scoped=true&"
import script from "./type2.vue?vue&type=script&lang=js&"
export * from "./type2.vue?vue&type=script&lang=js&"
import style0 from "./type2.vue?vue&type=style&index=0&id=2d05f728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05f728",
  null
  
)

export default component.exports